import React from 'react'
import { formatMenuInstant } from '../../lib/date'

export const EMPTY_CONTRACT = {
  id: null,
  orgId: '',
  billingMode: 'ORG_PAYS',
  appliedPlanCode: 'STANDARD',
  seatCountPolicy: 'APPROVED_MEMBER_COUNT',
  contractedSeats: 0,
  status: 'ACTIVE',
  contactEmail: '',
  contactPhone: '',
  notes: '',
  startedAt: '',
  endsAt: '',
  graceUntil: '',
}

export const EMPTY_OVERRIDE = {
  id: null,
  orgContractId: '',
  planCode: 'STANDARD',
  priceMode: 'PERCENT_DISCOUNT',
  discountRate: 0,
  fixedPrice: 0,
  seatFrom: 0,
  seatTo: 999999,
  priorityNo: 100,
  startedAt: '',
  endsAt: '',
}

export function toLocalInputValue(value) {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function displayDateTime(value) {
  return formatMenuInstant({ createdAt: value }, 'createdAt')
}

export function billingModeLabel(value) {
  if (!value) return '-'
  const u = String(value).toUpperCase()
  if (u === 'ORG_PAYS') return '조직 결제'
  if (u === 'MEMBER_PAYS_WITH_ORG_DISCOUNT') return '조직 할인 개인 결제'
  if (u === 'MEMBER_PAYS') return '멤버 결제'
  if (u === 'INDIVIDUAL' || u === 'USER_PAYS') return '개인 결제'
  return value
}

export function seatCountPolicyLabel(value) {
  if (!value) return '-'
  const u = String(value).toUpperCase()
  if (u === 'APPROVED_MEMBER_COUNT') return '승인된 멤버 수 기준'
  if (u === 'CONTRACTED_SEATS') return '계약 좌석 수 기준'
  return value
}

export function priceModeLabel(value) {
  if (!value) return '-'
  const u = String(value).toUpperCase()
  if (u === 'PERCENT_DISCOUNT') return '정률 할인(%)'
  if (u === 'FIXED_PRICE') return '고정 단가'
  return value
}

export function statusLabel(value) {
  if (value === 'ACTIVE') return '활성'
  if (value === 'TERMINATING') return '종료예정(유예)'
  if (value === 'INACTIVE') return '비활성'
  return value || '-'
}

export function effectiveStateLabel(contract) {
  if (!contract) return '-'
  const code = contract.effectiveState
  switch (code) {
    case 'EFFECTIVE':
      return '현재 유효'
    case 'NOT_STARTED':
      return '시작 전(시작일 미도래)'
    case 'ENDED':
      return '기간 만료(종료일 경과)'
    case 'INACTIVE_CONTRACT_STATUS':
      if (contract.status === 'INACTIVE') return '비활성(종료 처리됨)'
      return '유효하지 않은 계약 상태'
    case 'UNKNOWN':
      return '알 수 없음'
    default:
      break
  }
  if (contract.currentlyEffective) return '현재 적용 중'
  return '현재 미적용'
}

export function snapshotStatusLabel(value) {
  if (value === 'PROCESSED') return '처리 완료'
  if (value === 'SNAPSHOT_CREATED') return '스냅샷 생성'
  return value || '-'
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-slate-700">{label}</label>
      {children}
    </div>
  )
}

export function contractFromApiRow(contract) {
  return {
    id: contract.id,
    orgId: String(contract.orgId || ''),
    billingMode: contract.billingMode === 'MEMBER_PAYS_WITH_ORG_DISCOUNT' ? 'ORG_PAYS' : (contract.billingMode || 'ORG_PAYS'),
    appliedPlanCode: contract.appliedPlanCode || 'STANDARD',
    seatCountPolicy: contract.seatCountPolicy || 'APPROVED_MEMBER_COUNT',
    contractedSeats: contract.contractedSeats || 0,
    status: contract.status || 'ACTIVE',
    contactEmail: contract.contactEmail || '',
    contactPhone: contract.contactPhone || '',
    notes: contract.notes || '',
    startedAt: toLocalInputValue(contract.startedAt),
    endsAt: toLocalInputValue(contract.endsAt),
    graceUntil: toLocalInputValue(contract.graceUntil),
  }
}

export function overrideFromApiRow(override) {
  return {
    id: override.id,
    orgContractId: String(override.orgContractId || ''),
    planCode: override.planCode || 'STANDARD',
    priceMode: override.priceMode || 'PERCENT_DISCOUNT',
    discountRate: override.discountRate || 0,
    fixedPrice: override.fixedPrice || 0,
    seatFrom: override.seatFrom || 0,
    seatTo: override.seatTo || 999999,
    priorityNo: override.priorityNo || 100,
    startedAt: toLocalInputValue(override.startedAt),
    endsAt: toLocalInputValue(override.endsAt),
  }
}
